import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { UseCase } from "../../base/use-case";
import { MasterlocationRepository } from "../../repositories/master-location.repository";
import { SelectedSegmentId } from "../../domain/models/private-location/selected-building-block-id";

@Injectable({ providedIn: 'root' })
export class GetSegmentIdUsecase implements UseCase<null, SelectedSegmentId[]> {

  constructor(private readonly masterlocationRepository: MasterlocationRepository) {
  }

  execute(): Observable<SelectedSegmentId[]> {
    return this.masterlocationRepository.getSegmentIds();
  }

}